export const MOBILE_BREAKPOINT = 1024

export const DOM_IDS = {
  MOBILE_TOGGLE_WRAPPER: 'super-sidebar-toggle-button-wrapper',
  LOGO_CONTAINER: 'common-header-logo-container',
  LEFT_SLOTS: 'common-header-left-slots',
  RIGHT_SLOTS: 'common-header-right-slots',
  RIGHT_CONTAINER: 'common-header-right-container',
  BILLING_CART: 'common-header-billing-persistent-cart',
  HEADER_CONTAINER: 'header_container',
  SIMPLIFIED_FOOTER_COPYRIGHT: 'simplified-footer-copyright'
}

export const LOGO_TEXT = {
  ADMIN_CENTER: 'Admin center',
  SUB_ACCOUNT: 'Managing sub account',
  EXTERNAL_ACCOUNT: 'Managing delegated account'
}
